import type { CSSProperties } from "react";
import { Typography } from "antd";

const { Text } = Typography;

export const PREVIEW_DISCLAIMER_TEXT =
  "(Final visual depends on data availability in the selected range)";

/**
 * Unified caption for every data-driven widget preview: the preview uses sample
 * data, so the real result depends on what's available in the selected range.
 * Defaults to right-aligned for the preview title row; pass `style` to reposition.
 */
export function PreviewDisclaimer({ style }: { style?: CSSProperties }) {
  return (
    <Text
      type="secondary"
      style={{ marginLeft: "auto", fontSize: 12, textAlign: "right", ...style }}
    >
      {PREVIEW_DISCLAIMER_TEXT}
    </Text>
  );
}
